import angular from 'angular';
import _ from 'lodash';
import moment from 'moment';

(function () {
    'use strict';
    angular.module('app.core').factory('PrincipalDetail', PrincipalDetailData);

    PrincipalDetailData.$inject = ['$translate', 'PRINCIPAL', 'PrincipalPlatform', 'UtilSvc'];

    /* @ngInject */
    function PrincipalDetailData($translate, PRINCIPAL, PrincipalPlatform, UtilSvc) {
        PrincipalDetail.prototype = {
            build: build,
            buildEmpty: buildEmpty,
            setCountry: setCountry,
            prepareForServer: prepareForServer,
            getPlateformLabel: getPlateformLabel,
            getNameWithEid: getNameWithEid,
            getName: getName,
            isPlatformSelected: isPlatformSelected,
            isConfigPortail: isConfigPortail,
        };

        function PrincipalDetail(principalDetailData) {
            if (!principalDetailData) {
                this.buildEmpty();
            } else {
                this.build(principalDetailData);
            }
        }

        return PrincipalDetail;

        /////////////////////

        function buildEmpty() {
            this.id = null;
            this.eid = null;
            this.appId = null;
            this.creationDate = null;
            this.corporateName = null;
            this.countryCode = null;
            this.langCode = PRINCIPAL.langs[0];
            this.address1 = null;
            this.address2 = null;
            this.city = null;
            this.zipCode = null;
            this.state = null;
            this.plateform = PRINCIPAL.plateforms[0];
            this.plateformId = null;
            this.platformPath = null;
            this.profilBuyer = false;
            this.profilSeller = false;
            this.profilSellerInvited = false;
            this.processP2p = false;
            this.processO2c = false;
            this.discussInvoiceEm = false;
            this.facturXDeposit = false;
            this.eInvoiceEntry = false;
            this.managingInvoicer = false;
            this.discussInvoiceRe = false;
            this.managingInvoicee = false;
            this.discussOrderEm = false;
            this.discussOrderRe = false;
            this.dematPlatforms = [];
            this.orderEm = false;
            this.orderRe = false;
            this.threeWayMatching = false;
            this.threeWayMatchingRef = null;
            this.ssoActivated = null;
            this.ssoIdentifier = null;
            this.profilBuyerInvited = null;
            this.invoiceStatementsEnabled = null;
            this.orderResponseRe = false;
            this.orderDesAdvRe = false;
            this.orderRecAdvRe = false;
            this.orderResponseEm = false;
            this.orderPortalNotifEm = false;
            this.orderDesAdvEm = false;
            this.orderDisplayDesAdvEm = false;
            this.orderRecAdvEm = false;
            this.managingReferential = false;
            this.hasDocumentarySpace = false;
            this.authorizedPdpEm = false;
            this.authorizedPdpRe = false;
            this.businessModelReform = null;
            this.controlSetReform = null;
            this.businessModelFactureX = null;
            this.eligibilityEnrichmentSet = null;
            this.invInErrorReportFrequency = PRINCIPAL.reportFrequencies[3]; // NEVER;
            this.invInErrorReportMail = null;
            this.pcpSellerPlatformPathFacturX = null;
            this.eInvoicingPlatformPath = null;
            this.ssoDomains = [];
        }

        function build(principalDetailData) {
            this.id = principalDetailData.id || null;
            this.appId = principalDetailData.appId || null;
            this.eid = principalDetailData.eid || null;
            this.creationDate = _initDate(principalDetailData.creationDate);
            this.corporateName = principalDetailData.corporateName || null;
            this.countryCode = principalDetailData.countryCode || null;
            this.langCode = principalDetailData.langCode || null;
            this.address1 = principalDetailData.address1 || null;
            this.address2 = principalDetailData.address2 || null;
            this.city = principalDetailData.city || null;
            this.zipCode = principalDetailData.zipCode || null;
            this.state = principalDetailData.state || null;
            this.plateform = principalDetailData.plateform || null;
            this.dematPlatforms = transformPlateforms(principalDetailData.dematPlatforms) || [];
            this.plateformId = principalDetailData.plateformId || null;
            this.platformPath = principalDetailData.platformPath || null;
            this.profilBuyer = principalDetailData.profilBuyer;
            this.profilSeller = principalDetailData.profilSeller;
            this.profilSellerInvited = principalDetailData.profilSellerInvited;
            this.processP2p = principalDetailData.processP2p;
            this.processO2c = principalDetailData.processO2c;
            this.discussInvoiceEm = principalDetailData.discussInvoiceEm;
            this.facturXDeposit = principalDetailData.facturXDeposit;
            this.eInvoiceEntry = principalDetailData.eInvoiceEntry;
            this.managingInvoicer = principalDetailData.managingInvoicer;
            this.discussInvoiceRe = principalDetailData.discussInvoiceRe;
            this.managingInvoicee = principalDetailData.managingInvoicee;
            this.discussOrderEm = principalDetailData.discussOrderEm;
            this.discussOrderRe = principalDetailData.discussOrderRe;
            this.orderEm = principalDetailData.orderEm;
            this.threeWayMatching = principalDetailData.threeWayMatching;
            this.threeWayMatchingRef = principalDetailData.threeWayMatchingRef;
            this.ssoActivated = principalDetailData.ssoActivated;
            this.ssoIdentifier = principalDetailData.ssoIdentifier;
            this.profilBuyerInvited = principalDetailData.profilBuyerInvited;
            this.invoiceStatementsEnabled = principalDetailData.invoiceStatementsEnabled;
            this.orderResponseRe = principalDetailData.orderResponseRe;
            this.orderDesAdvRe = principalDetailData.orderDesAdvRe;
            this.orderRecAdvRe = principalDetailData.orderRecAdvRe;
            this.orderRe = principalDetailData.orderRe;
            this.orderResponseEm = principalDetailData.orderResponseEm;
            this.orderPortalNotifEm = principalDetailData.orderPortalNotifEm;
            this.orderDesAdvEm = principalDetailData.orderDesAdvEm;
            this.orderDisplayDesAdvEm = principalDetailData.orderDisplayDesAdvEm;
            this.orderRecAdvEm = principalDetailData.orderRecAdvEm;
            this.managingReferential = principalDetailData.managingReferential;
            this.hasDocumentarySpace = principalDetailData.hasDocumentarySpace;
            this.authorizedPdpEm = principalDetailData.authorizedPdpEm;
            this.authorizedPdpRe = principalDetailData.authorizedPdpRe;
            this.businessModelReform = principalDetailData.businessModelReform;
            this.controlSetReform = principalDetailData.controlSetReform;
            this.businessModelFactureX = principalDetailData.businessModelFacturX;
            this.eligibilityEnrichmentSet = principalDetailData.eligibilityEnrichmentSet;
            this.invInErrorReportFrequency =
                principalDetailData.invInErrorReportFrequency || PRINCIPAL.reportFrequencies[3];
            this.invInErrorReportMail = UtilSvc.splitMail(principalDetailData.invInErrorReportMail);
            this.pcpSellerPlatformPathFacturX = principalDetailData.pcpSellerPlatformPathFacturX || null;
            this.eInvoicingPlatformPath = principalDetailData.eInvoicingPlatformPath || null;
            this.isHubPharmaEnabled = principalDetailData.hubPharmaEnabled;
            this.ssoDomains = principalDetailData.ssoDomains ? principalDetailData.ssoDomains.map(item => ({text:item})) : [];
        }

        function transformPlateforms(platforms) {
            return platforms ? platforms.map(element => new PrincipalPlatform(element)) : null;
        }

        function _initDate(date) {
            if (date) {
                return moment(date).toDate();
            }
            return new Date();
        }

        /**
         * Récupération du pays selon son country code
         */
        function setCountry(countries) {
            if (this.countryCode && countries) {
                this.country = _.find(countries, { code: this.countryCode });
            }
        }

        /**
         * Recopie les identifiant des listes déroulantes dans le champ qui va bien
         */
        function prepareForServer() {
            if (this.country) {
                this.countryCode = this.country.code;
            }
            if (this.lang) {
                this.langCode = this.lang.id;
            }
            this.invInErrorReportMail = UtilSvc.joinMail(this.invInErrorReportMail);
            this.ssoDomains = UtilSvc.formatDomainNames(this.ssoDomains);
        }

        function getPlateformLabel() {
            if (this.plateform) {
                return $translate.instant('principal.plateforms.' + angular.lowercase(this.plateform));
            }
            return '';
        }

        function getNameWithEid() {
            return this.corporateName + ' (' + this.eid + ')';
        }

        /**
         * Fournit le nom et l'eid du donneur d'ordres.
         * La fonction s'appelle "getName" pour son utilisation dans Typeahead afin d'avoir le même même nom que dans seller.data.
         */
        function getName() {
            return this.getNameWithEid();
        }
        /**
         * Permet de vérifier si la famille de la plateforme en paramétre est selectionnée pour le DO
         * @param {*} platformFamily Famille de plateforme
         */
        function isPlatformSelected(platformFamily) {
            return !!this.dematPlatforms.find(element => element.family === platformFamily);
        }

        /**
         * Permet l'on a parametré la configuration du portail
         */
        function isConfigPortail() {
            return this.processP2p || this.processO2c;
        }
    }
})();
